import styled from 'styled-components'

export const CaptionContainer = styled.div<{ componentStyle?: string }>`
    ${(props) => props.componentStyle}
    color: var(--dashboard-secondary-color);
    font-size: 0.825em;
    display: flex;
    align-items: flex-start;

    svg {
        width: 100px;
        opacity: 0.9;
        margin-right: 10px;
        margin-left: 10px;
    }
`

export const CaptionText = styled.span`
    flex: 1;
`
